import React from 'react';
import { useAppState } from '../../../hooks/use-app-state.hook';
import Content from '../../layout/content/content.component';
import Page from '../../layout/page/page.component';
import SectionInfo from '../../layout/section-info/section-info.component';

const PrivacyNoticePage: React.FC = () => {
    const [, {getPage}] = useAppState();
    const pageData = getPage('Privacy Notice');

    return (
        <Page vCentered>
            <Content>
                { pageData && (
                    <SectionInfo imageUrl={ pageData.imageUrl }>
                        <span dangerouslySetInnerHTML={ {__html: pageData.html} }/>
                    </SectionInfo>
                ) }
            </Content>
        </Page>
    );
};

export default PrivacyNoticePage;
